module.exports = __webpack_public_path__ + "img/UpdateObjectiveProgress.40c91741.png";